import { TrainerCommunity, CreateTrainerCommunity } from '#types/tmmunity.type';
import request from '#api/axios';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useFormContext } from 'react-hook-form';
import { useToast } from '#providers/ToastProvider';
import { AxiosError } from 'axios';

export const createTmmunity = async ({
  category,
  content,
  title
}: CreateTrainerCommunity) => {
  const res = await request<string>({
    method: 'post',
    url: '/trainers',
    data: {
      category,
      content,
      title
    }
  });
  return res.data;
};

export const useCreateCommunityMutation = () => {
  const mutation = useMutation(createTmmunity);
  return mutation;
};

export const getTmmunityDetail = async (questionId: string) => {
  const res = await request<TrainerCommunity>({
    method: 'get',
    url: `/trainers/${questionId}`
  });
  return res.data;
};

export const useGetTmmunityDetailQuery = (questionId: string) =>
  useQuery(['getTmmunityDetail'], () => getTmmunityDetail(questionId));

export interface PostTmmunityCommnetParams {
  questionId: string;
  content: string;
  sequence?: number;
  originalAnswerId?: number;
  writerId: string;
  receiverId?: string;
}

export const postTrainerCommunityComments = async (
  questionId: string,
  param: PostTmmunityCommnetParams
) => {
  const res = await request<string>({
    method: 'post',
    url: `/trainers/${questionId}/comments`,
    data: param
  });
  return res;
};

export const postInformationCommunityComments = async (
  questionId: string,
  param: PostTmmunityCommnetParams
) => {
  const res = await request<string>({
    method: 'post',
    url: `/consumer/exercise/${questionId}/answers`,
    data: param
  });
  return res;
};

export const usePostTmmunityCommentMutation = (questionId: string) => {
  const { showToast } = useToast();
  const { reset } = useFormContext();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (param: PostTmmunityCommnetParams) =>
      await postTrainerCommunityComments(questionId, param),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['get-trainer-community-thread-comment']
      });
      queryClient.invalidateQueries({
        queryKey: ['get-trainer-community-thread-comment-count']
      });
      return reset({ content: '' });
    },
    onError: (e: AxiosError) => {
      if (e.response?.status === 401) {
        showToast({
          type: 'fail',
          message: '로그인이 필요합니다.'
        });
        reset({ content: '' });
        return;
      }
      showToast({
        type: 'fail',
        message: '댓글 등록에 실패했습니다.'
      });
    }
  });
  return mutation;
};

export const usePostInformationCommentMutation = (
  questionId: string,
  param: PostTmmunityCommnetParams
) => {
  const { reset } = useFormContext();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async () =>
      await postInformationCommunityComments(questionId, param),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['get-information-community-thread-comment']
      });
      queryClient.invalidateQueries({
        queryKey: ['get-information-community-thread-comment-count']
      });
      return reset({ content: '' });
    }
  });
  return mutation;
};
